var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBfidTier1BadgeShort = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 73,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 24,
  x: 0.5,
  fill: "url(#bfid-tier-1-badge-short_svg__a)",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.976 9.263h-2.398V16h-1.48V9.262H8.702V8.047h6.275zM17.612 16h-1.485V8.047h1.485zm3.376-6.776v2.206h2.783v1.138h-2.783v2.25h3.53V16h-5.015V8.047h5.016v1.177zm7.355 2.607q.42 0 .726-.104.314-.104.512-.287a1.2 1.2 0 0 0 .302-.44q.1-.252.1-.555 0-.604-.402-.93-.397-.324-1.216-.324h-.946v2.64zM32.15 16h-1.336q-.38 0-.55-.297l-1.672-2.546a.6.6 0 0 0-.21-.204.7.7 0 0 0-.33-.06h-.632V16h-1.48V8.047h2.426q.81 0 1.386.17.584.165.952.468.375.303.55.726.176.418.176.924 0 .401-.121.759-.115.357-.341.649-.22.292-.55.511a2.7 2.7 0 0 1-.743.347q.144.083.264.198.121.11.22.264zm8.561-1.018V16h-4.4v-1.018h1.612v-4.636q0-.275.016-.566l-1.144.957a.5.5 0 0 1-.198.098.5.5 0 0 1-.33-.055.4.4 0 0 1-.099-.093l-.429-.588 2.426-2.063h1.116v6.947zm4.49-7.49h1.057v10.4H45.2zm12.27.626L54.258 16h-.957L50.09 8.118h.853q.143 0 .23.072a.44.44 0 0 1 .133.181l2.222 5.561q.07.187.137.407.072.22.127.462.055-.242.115-.462t.132-.407l2.217-5.56a.4.4 0 0 1 .126-.171.36.36 0 0 1 .237-.083zm4.742 4.956-1.238-3.206a7 7 0 0 1-.23-.738 6 6 0 0 1-.237.743l-1.238 3.201zM64.434 16h-.825a.36.36 0 0 1-.231-.072.44.44 0 0 1-.132-.181l-.737-1.903h-3.537l-.737 1.903a.4.4 0 0 1-.126.176.35.35 0 0 1-.231.077h-.825l3.151-7.882h1.078z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bfid-tier-1-badge-short_svg__a",
  x1: 62.183,
  x2: 28.17,
  y1: -18.385,
  y2: 51.534,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D66D56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#F79668"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.639,
  stopColor: "#ED8959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D16C61"
})))));
export default SvgBfidTier1BadgeShort;